import { render, staticRenderFns } from "./MenusPdd.vue?vue&type=template&id=d03db2fa&scoped=true&"
import script from "./MenusPdd.vue?vue&type=script&lang=js&"
export * from "./MenusPdd.vue?vue&type=script&lang=js&"
import style0 from "./MenusPdd.vue?vue&type=style&index=0&id=d03db2fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03db2fa",
  null
  
)

export default component.exports